"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionCampaignTimeConditionMode = void 0;
var CommissionCampaignTimeConditionMode;
(function (CommissionCampaignTimeConditionMode) {
    CommissionCampaignTimeConditionMode["CreatedAt"] = "createdAt";
    CommissionCampaignTimeConditionMode["DepartureAt"] = "departureAt";
})(CommissionCampaignTimeConditionMode || (exports.CommissionCampaignTimeConditionMode = CommissionCampaignTimeConditionMode = {}));
//# sourceMappingURL=commission-campaign-time-condition.enum.js.map